import axios from '@/libs/api.request'

export const savePluginData = (plugin, data) => {
  return axios.request({
    url: `/bom/plugin/bom_item_data_ext/${plugin}`,
    method: 'post',
    data: data
  })
}

export const getPluginData = (plugin, query) => {
  const queryStr = Object.entries(query).reduce((a, [k, v]) => {
    a.push(`${k}=${v}`)
    return a
  }, []).join('&')

  return axios.request({
    url: `/bom/plugin/bom_item_data_ext/${plugin}?${queryStr}`,
    method: 'get'
  })
}

export const deletePluginData = (plugin, params) => {
  return axios.request({
    url: `/bom/plugin/bom_item_data_ext/${plugin}`,
    method: 'delete',
    data: params
  })
}
